export const addClass = (className: string, classes: string[] | undefined) => {
  if (!classes) {
    return ['hidden']
  }
  const _classes = [...classes]
  if (!_classes.includes(className)) {
    _classes.push(className)
  }
  return _classes
}

export const removeClass = (
  className: string,
  classes: string[] | undefined,
) => {
  if (!classes) return
  return classes.filter((c) => c !== className)
}
